import { render } from "./HostRedfishTab.vue?vue&type=template&id=44961bac&scoped=true"
import script from "./HostRedfishTab.vue?vue&type=script&lang=js"
export * from "./HostRedfishTab.vue?vue&type=script&lang=js"

import "./HostRedfishTab.vue?vue&type=style&index=0&id=44961bac&scoped=true&lang=css"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44961bac"]])

export default __exports__